import { Component, ElementRef, OnInit } from '@angular/core';
import { LoadingService, LoadingState } from '../../services/loading';

@Component({
    selector: 'app-loading-overlay',
    templateUrl: './loading-overlay.component.html'
})
export class LoadingOverlayComponent implements OnInit {
    state: LoadingState = { visible: false, message: 'Caricamento' };

    constructor(private loadingService: LoadingService,
                private elementRef: ElementRef<HTMLElement>) {
        this.loadingService.state$.subscribe(state => this.state = state);
    }

    ngOnInit(): void {
        document.body.appendChild(this.elementRef.nativeElement);
    }
}
